/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const bubbleTokens = {
  FontFamilyBaseDefault: '"Inter var", "fallback for Inter", sans-serif',
  FontSizeBaseDefault: '12px',
  FontWeightBaseDefault: '500',
  FontColorCommonDefault: '#ffffff',
  FontColorPreferredDefault: '#ffffff',
  FontColorConvertibleDefault: '#ffffff',
  FontColorWarrantDefault: '#ffffff',
  FontColorOptionDefault: '#1c2222',
  FontColorPoolDefault: '#1c2222',
  FontColorPositiveDefault: '#1e6a60',
  FontColorNegativeDefault: '#831124',
  FontColorNoticeDefault: '#a0563f',
  FontColorPendingDefault: '#825a00',
  FontColorInformationalDefault: '#285da3',
  FontColorNeutralDefault: '#394040',
  FontColorStaffDefault: '#000000',
  FontColorPurpleDefault: '#754ea0',
  FontColorBlueDarkDefault: '#ffffff',
  FontColorGrayDefault: '#ffffff',
  FontColorWhiteDefault: '#232b2b',
  FontColorGreenDefault: '#1e6a60',
  FontColorRedDefault: '#ae1630',
  FontColorOrangeDefault: '#a0563f',
  FontColorYellowDefault: 'rgb(103, 77, 5)',
  FontColorBlueDefault: '#1a3e6d',
  FontColorGrayLightDefault: '#656b6b',
  BorderStyleBaseDefault: 'solid',
  BorderWidthBaseDefault: '1px',
  BorderRadiusBaseDefault: '12px',
  BorderColorPurpleDefault: '#ebe5f5',
  BorderColorBlueDarkDefault: '#2c67b5',
  BorderColorGrayDefault: '#394040',
  BorderColorWhiteDefault: '#dedfdf',
  BorderColorGreenDefault: '#addfd9',
  BorderColorRedDefault: '#f0a4b1',
  BorderColorOrangeDefault: '#f5cabd',
  BorderColorYellowDefault: '#fbe284',
  BorderColorBlueDefault: '#c0d1e9',
  BorderColorGrayLightDefault: '#c4c4c4',
  BackgroundColorCommonDefault: '#32b0a0',
  BackgroundColorPreferredDefault: '#2c67b5',
  BackgroundColorConvertibleDefault: '#634ba0',
  BackgroundColorWarrantDefault: '#ea657f',
  BackgroundColorOptionDefault: '#a7aaaa',
  BackgroundColorPoolDefault: '#c4c4c4',
  BackgroundColorPositiveDefault: '#d6efec',
  BackgroundColorNegativeDefault: '#f8d2d8',
  BackgroundColorNoticeDefault: '#fcf0ee',
  BackgroundColorPendingDefault: '#fef8da',
  BackgroundColorInformationalDefault: '#dfe8f4',
  BackgroundColorNeutralDefault: '#ebecec',
  BackgroundColorStaffDefault: '#efb09c',
  BackgroundColorPurpleDefault: '#ebe5f5',
  BackgroundColorBlueDarkDefault: '#2c67b5',
  BackgroundColorGrayDefault: '#394040',
  BackgroundColorWhiteDefault: '#ffffff',
  BackgroundColorGreenDefault: '#d6efec',
  BackgroundColorRedDefault: '#f8d2d8',
  BackgroundColorOrangeDefault: '#fae5de',
  BackgroundColorYellowDefault: '#fffced',
  BackgroundColorBlueDefault: '#dfe8f4',
  BackgroundColorGrayLightDefault: '#dedfdf',
  SpacingInnerVerticalBaseDefault: '2px',
  SpacingInnerHorizontalBaseDefault: '8px',
} as const;
